"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelsAI = void 0;
const modelsAIPostValuatorModelsSaleValuationPost_js_1 = require("../funcs/modelsAIPostValuatorModelsSaleValuationPost.js");
const sdks_js_1 = require("../lib/sdks.js");
const fp_js_1 = require("./types/fp.js");
class ModelsAI extends sdks_js_1.ClientSDK {
    /**
     * Post Valuator
     *
     * @remarks
     * Get an updated property sale value based on a corrected property type and/or number of bedrooms.
     *
     * ## Query parameters
     *
     * | Parameter                       | Description                                                                                                    |
     * |:--------------------------------|:---------------------------------------------------------------------------------------------------------------|
     * | `street_group_property_id`      | The unique identifier associated with the property request                                                     |
     * | `property_type`      (optional) | The The property type, which should be one of: 'Detached', 'Semi-Detached', 'Terraced', 'Flats/Maisonettes' |
     * | `number_of_bedrooms` (optional) | The number of bedrooms, truncated between 1 and 5                                                              |
     *
     * ## Responses
     * The function uses the `street_group_property_id` to fetch the remaining property details and then calculates the sale value based on the corrected property type and number of bedrooms.
     *
     * `200 OK` Returns The updated property's estimated sale value.
     *
     * `404 Not Found` Is returned if the `street_group_property_id` passed wasn't matched to a property
     */
    async postValuatorModelsSaleValuationPost(security, request, options) {
        return (0, fp_js_1.unwrapAsync)((0, modelsAIPostValuatorModelsSaleValuationPost_js_1.modelsAIPostValuatorModelsSaleValuationPost)(this, security, request, options));
    }
}
exports.ModelsAI = ModelsAI;
//# sourceMappingURL=modelsai.js.map